// extracted by mini-css-extract-plugin
export default {"authorLoginLink":"IssueBodyHeaderAuthor-module__authorLoginLink__sLcQc0c"};